<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { Button, InputText, Message, Checkbox } from 'primevue';
import { ref } from 'vue';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { useRouter } from 'vue-router';
import { useThemeStore } from 'shared/themes/stores/themeStore';

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

const router = useRouter();

const localStorageUsername = 'login-username';
const localStorageSaveUsername = 'login-save-username';

const username = ref(localStorage.getItem(localStorageUsername) ?? '');
const saveUsername = ref(localStorage.getItem(localStorageSaveUsername) === 'true');

const themeStore = useThemeStore()
const themeName = themeStore.currentTheme === "SILog" ? " SILog!" : " TiYard!"

function onSignInClick() {
  if (saveUsername.value) {
    localStorage.setItem(localStorageUsername, username.value);
    localStorage.setItem(localStorageSaveUsername, 'true');
  } else {
    localStorage.removeItem(localStorageUsername);
    localStorage.setItem(localStorageSaveUsername, 'false');
  }

  router.push({ name: 'login', query: { 'username': username.value } });
}

</script>

<template>
  <div class="bg-surface-100 dark:bg-surface-950 flex items-center justify-center min-h-screen overflow-hidden">
    <div class="flex flex-col items-center justify-center">
      <div
        style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, var(--p-primary-color) 10%, rgba(33, 150, 243, 0) 30%)">
        <div class="w-full bg-surface-0 dark:bg-surface-900 py-6 px-6 sm:px-20" style="border-radius: 53px">
          <div class="text-center mb-8">
            <img v-if="themeStore.currentTheme === 'SILog'" class="silog-icon" src="/silog-symbol-vit.png" />
            <img v-if="themeStore.currentTheme === 'TiYard'" class="tiyard-icon" src="/TiYard_favicon.png" />
            <div class="text-surface-900 dark:text-surface-0 text-3xl font-medium mb-4 px-10">
              {{ translations.home.welcome + themeName }}
            </div>
            <span class="text-muted-color font-medium">{{ translations.home.description }}</span>
            <div class="flex flex-col gap-1 items-start mt-3">
              <label for="username">{{ translations.home.username }}</label>
              <InputText type="text" class="w-full" name="username" v-model="username" autocomplete="username">
              </InputText>
              <Message size="small" severity="secondary" variant="simple">{{ translations.home.enterUsername }}
              </Message>
              <div class="flex items-center gap-1">
                <Checkbox v-model="saveUsername" inputId="saveUsername" name="saveUsername" binary />
                <label for="saveUsername"> {{ translations.home.rememberUsername }} </label>
              </div>
            </div>
            <Button :label="translations.home.signInButton" class="w-full mt-4" @click="onSignInClick()"
              :disabled="!username"></Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.silog-icon {
  max-height: 3rem;
  margin-inline: auto;
  margin-bottom: 1rem;
}

.tiyard-icon {
  max-height: 3rem;
  margin-inline: auto;
  margin-bottom: 1rem;
}
</style>
